export default function GetInteger(input){
    return Math.floor(input)
}